{
  "clearThisNote": "Vuoi cancellare questa nota?",
  "deviceComment": "Commento",
  "leaveANote": "Lascia una nota",
  "newDeviceComment": "Nuovo commento sul dispositivo",
  "thisCommentWillBeVisibleToAllOtherUsersAssociatedWithYourFarmAccount": "Questo commento sarà visibile a tutti gli altri utenti associati al tuo account agricolo."
}
